import { API, graphqlOperation } from "aws-amplify";
import { memoryByCustomerIdAndKey } from "../graphql/queries";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { MemoryByCustomerIdAndKeyQuery } from "../API";
import { updateLLMMemory } from "../graphql/mutations";
import { UpdateLLMMemoryInput, UpdateLLMMemoryMutation } from "../API";

export async function fetchLLMMemoriesByCustomerId(
  customerId: string
): Promise<GraphQLResult<MemoryByCustomerIdAndKeyQuery>> {
  return API.graphql(
    graphqlOperation(memoryByCustomerIdAndKey, {
      customerId: customerId,
    })
  ) as Promise<GraphQLResult<MemoryByCustomerIdAndKeyQuery>>;
}

export async function updateLLMMemoryStatus(
  input: UpdateLLMMemoryInput
): Promise<GraphQLResult<UpdateLLMMemoryMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMMemory, {
      input: input,
    })
  ) as Promise<GraphQLResult<UpdateLLMMemoryMutation>>;
}


